module.exports = __webpack_public_path__ + "img/bottom-image.20d6a53f.jpg";